import { Tooltip, TooltipProps } from '@chakra-ui/react';
import React from 'react';

export const CmTooltip: React.FC<TooltipProps> = ({
  children,
  hasArrow = true,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <Tooltip {...{ hasArrow, ...rest }}>{children}</Tooltip>;
};
